export enum ChainType {
    Sol = "Solana",
    Eth = "Polygon Testnet"
}